import BackButton from "@/components/BackButton";
import { API } from "@/lib/api";
import { useConfig } from "@/lib/data";

export function AuthShell({ title, subtitle, children, backTo = "/", forceBack = false }) {
  return (
    <div className="mx-auto max-w-md px-4 py-6 sm:px-6">
      <BackButton to={backTo} forceTo={forceBack} />
      <h1 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 text-lg text-slate-700">{subtitle}</p>}
      <div className="mt-6">{children}</div>
    </div>
  );
}

export function GoogleButton({ next }) {
  const { data: cfg } = useConfig();
  const go = () => {
    sessionStorage.setItem("po_next", next || "/perfil");
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (cfg?.google_own_origins?.includes(window.location.origin)) {
      // Own Google Cloud OAuth (Portuguese consent screen, site branding). Callback: <origin>/auth/google
      const params = new URLSearchParams({ origin: window.location.origin, next: next || "/perfil" });
      window.location.href = `${API}/auth/google/start?${params}`;
      return;
    }
    const redirectUrl = window.location.origin + "/perfil";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={go} className="po-btn-outline w-full min-h-[64px] border-slate-400 text-xl" data-testid="google-login-button">
      <svg width="24" height="24" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
      </svg>
      Continuar com Google
    </button>
  );
}

export function Divider() {
  return (
    <div className="my-5 flex items-center gap-3 text-base text-slate-500">
      <span className="h-px flex-1 bg-slate-200" /> ou <span className="h-px flex-1 bg-slate-200" />
    </div>
  );
}
